import { PropsWithChildren, createContext, useState } from 'react'
import { IntlProvider } from 'react-intl'

import { LANGUAGES } from 'app/consts'
import English from 'translations/en_US.json'
import French from 'translations/fr_CA.json'

const LANGUAGE_KEY = 'sav-language'
interface LocalizationContext {
  locale: string
  selectLanguage: (lang: string) => void
}

const initialLocalizationContext: LocalizationContext = {
  locale: '',
  selectLanguage: () => {},
}

export const Context = createContext<LocalizationContext>(
  initialLocalizationContext
)

const currentAppLanguage = localStorage.getItem(LANGUAGE_KEY)

const local = currentAppLanguage || navigator.language

let lang: Record<string, string>

switch (local) {
  case LANGUAGES.EN_US:
    lang = English
    break
  case LANGUAGES.FR_CA:
    lang = French
    break
  default:
    lang = English
}

interface LocalizationWrapperProps {}

function LocalizationWrapper(
  props: PropsWithChildren<LocalizationWrapperProps>
) {
  const [locale, setLocale] = useState(local)
  const [messages, setMessages] = useState(lang)

  const selectLanguage = (lang: string) => {
    setLocale(lang)

    lang === LANGUAGES.EN_US && setMessages(English)
    lang === LANGUAGES.FR_CA && setMessages(French)
    localStorage.setItem(LANGUAGE_KEY, lang)
  }

  return (
    <Context.Provider value={{ locale, selectLanguage }}>
      <IntlProvider messages={messages} locale={locale}>
        {props.children}
      </IntlProvider>
    </Context.Provider>
  )
}

export default LocalizationWrapper
